import React from "react"

const style = {
  textAlign: `center`,
  lineHeight: `1`,
  fontSize: `1rem`,
}

const Footer = () => (
  <footer  style={{padding: `0.5rem`}}>
    <h5  style={style}>AERODYNAMICS CLUB © 2020</h5>
  </footer>
)

export default Footer
